import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../context/authContext';
import { getUserImageLimits } from '../api/api';
import type { UserImageLimits } from '@UserImageLimits';

export const useUserLimits = () => {
    const { user } = useAuth();
    const queryClient = useQueryClient();

    const query = useQuery({
        queryKey: ['user-limits', user?.id],
        queryFn: getUserImageLimits,
        enabled: !!user,
        staleTime: 30 * 1000, // 30 seconds
        refetchOnWindowFocus: false,
    });

    const setUserLimits = (next: UserImageLimits) => {
        if (!user) return;
        queryClient.setQueryData<UserImageLimits>(['user-limits', user.id], next);
    };

    return { ...query, setUserLimits };
};
